import { withMissingTranslationFallback } from 'shared/utils/withMissingTranslationFallback';

const MALE = 'MALE';
const FEMALE = 'FEMALE';
const OTHER = 'OTHER';
const UNKNOWN = 'UNKNOWN';

export const userGenderOptions = [
  MALE,
  FEMALE,
  OTHER,
  UNKNOWN,
];

const userGenderMessagesRaw = {
  MALE: { id: 'Gender.Male', defaultMessage: '** Male' },
  FEMALE: { id: 'Gender.Female', defaultMessage: '** Female' },
  OTHER: { id: 'Gender.Other', defaultMessage: '** Other' },
  UNKNOWN: { id: 'Gender.Unknown', defaultMessage: '** Unknown' },
  null: { id: 'General.Blank', defaultMessage: '-' },
};

export const userGenderMessages = withMissingTranslationFallback(userGenderMessagesRaw);
